const sectionSelector = '.case-studies-section.is-carousel';

let swiperDepsPromise = null;

function getSwiperDeps() {
	if (!swiperDepsPromise) {
		swiperDepsPromise = Promise.all([
			import('swiper'),
			import('swiper/modules'),
		]).then(([swiperModule, modules]) => ({
			Swiper: swiperModule.Swiper,
			Autoplay: modules.Autoplay,
			EffectFade: modules.EffectFade,
			Navigation: modules.Navigation,
			Pagination: modules.Pagination,
			A11y: modules.A11y,
		}));
	}

	return swiperDepsPromise;
}

const sectionCallBack = async (sectionElement, q) => {
	const sliderEl = q('.cs-slider');
	if (!sliderEl) return;
	if (sliderEl.swiperInstance) return;

	let Swiper;
	let Autoplay;
	let EffectFade;
	let Navigation;
	let Pagination;
	let A11y;

	try {
		({
			Swiper,
			Autoplay,
			EffectFade,
			Navigation,
			Pagination,
			A11y,
		} = await getSwiperDeps());
	} catch {
		return;
	}

	const paginationEl = q('.cs-pagination');
	const nextEl = q('.cs-nav-next');
	const prevEl = q('.cs-nav-prev');
	const slidesCount = sliderEl.querySelectorAll('.swiper-slide').length;

	const config = {
		modules: [Autoplay, EffectFade, Navigation, Pagination, A11y],
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		duration: 1000,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		slidesPerView: 1,
		loop: slidesCount > 1,
		a11y: {
			enabled: true,
		},
	};

	if (paginationEl) {
		config.pagination = {
			el: paginationEl,
			clickable: true,
		};
	}

	if (nextEl && prevEl) {
		config.navigation = {
			nextEl,
			prevEl,
		};
	}

	const swiper = new Swiper(sliderEl, config);
	sliderEl.swiperInstance = swiper;
};

export { sectionSelector, sectionCallBack };
